<template>
  <div class="relative flex flex-col justify-center items-center w-11/12 md:w-5/12 rounded-2xl bg-white py-6">
    <span @click="closeModal" class="absolute left-8 top-4 text-customGray text-sm cursor-pointer">Close</span>
    <WarningIcon class="mb-2"/>
    <h2 class="mb-2 text-center font-semibold text-yank">Are you sure you want to delete this folder?</h2>
    <span v-if="folder" class="mb-4 text-sm text-yank">{{folder.name}}</span>
    <form class="flex px-5 w-full" @submit.prevent="submit" >
        <button @click="closeModal" class="w-1/2 px-3 py-2 text-sm border-payneHot border-2 rounded-lg mr-2" type="button">Cancel</button>
        <button class="w-1/2 px-10 py-2 text-sm bg-payneHot rounded-lg text-white" type="submit">Yes, I want to delete</button> 
    </form>
</div>
</template>

<script>
import WarningIcon from '@/components/svg/WarningIcon.vue';

export default {
    name:"ConfirmDeleteModal",

    components:{
        WarningIcon
    },

    props:{
        folder:{
            type: Object,
            default: null
        }
    },
    
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
        submit(){
            this.$emit('delete', this.folder);
            this.closeModal();
        },
    },
}
</script>